import { Logger } from "../types/internal";

type Level = "info" | "debug" | "log" | "error";

const wrap = (method: Level) => {
  return (message: string, ...params: any[]) => {
    console[method](`[Orie SDK] ${message}`, ...params);
  };
};

export const logger: Logger = {
  info: wrap("info"),
  log: wrap("log"),
  debug: wrap("debug"),
  error: wrap("error"),
};
